export const KPI_UPDATE_STATE = "KPI_UPDATE_STATE"
